import React, { useEffect, useState } from 'react'

import { toast } from 'react-toastify'

import RecentContacts from '../../../../../presentation/pages/contractors/recent-contacts'

import { useMe } from '../../../../../presentation/contexts/me'

import { makeRequests } from '../../../../usecases/requests/remote-requests-factory'

import isHttpError from '../../../../../presentation/helpers/helper-http-error'
import useFetchConversations from '../../../../../presentation/hooks/fetch-conversations'

const MakeRecentContacts = () => {
  document.title = 'BuscarMédicos - Contatos recentes'

  const [requests, setRequests] = useState<any[]>([])

  const { me } = useMe()

  const conversations = useFetchConversations(me?.id)

  useEffect(() => {
    const loadRequests = async () => {
      try {
        if (me) {
          const data = await makeRequests(
            `/solicitations/${me.id}/contractors`,
          ).load()
          setRequests(data)
        }
      } catch (error) {
        const httpError = isHttpError(error)

        if (httpError) {
          toast.error(httpError.message)
        } else {
          throw error
        }
      }
    }

    loadRequests()
  }, [me])

  const recentContacts = requests.map((doctor) => ({
    ...doctor,
    linkChat: `/chat/MEDICO/${doctor.doctorId}`,
    linkProfile: `/contractors/doctor/${doctor.doctorId}`,
    hasNewMessage: conversations.some(
      (conversation) => conversation.id === String(doctor.doctorId)
        && conversation.messages.some(
          (message) => !message.isRead && message.receiverId === String(me?.id),
        ),
    ),
  }))

  return <RecentContacts recentContacts={recentContacts} />
}

export default MakeRecentContacts
